import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import {
  fetchGroupTrackerIfNeeded,
  fetchTrackerPlanIfNeeded,
  fetchTrackerTimelineViewIfNeeded,
  fetchTrackerPrimaryEntityDetailsIfNeeded,
  fetchTrackerTeasersAndTrailersIfNeeded,
  fetchTrackerpageWhatsNewIfNeeded,
  fetchTrackerpageWordCloudIfNeeded,
  setTrackerSelectedEntity,
  setSingleTrackerSelectedEntity,
  setSelectedSidebarNav,
  fetchAverageBenchMarkTrackerPlanIfNeeded,
  fetchAverageBenchMarkTrackerTimelineViewIfNeeded,
  fetchSingleTrackerEntityPlanIfNeeded,
  fetchSingleTrackerEntityTimelineViewIfNeeded,
  logout
} from '../../actions'
import {
  makeTrackerIdSelector,
  makeTrackerPlanSelector,
  makeTrackerTimelineViewSelector,
  makeTrackerPrimaryEntitySelector,
  makeTrackerTeasersAndTrailersSelector,
  makeTeaserAndTrailerState,
  makeAverageBenchMarkTrackerPlanSelector,
  makeAverageBenchMarkTrackerTimelineViewSelector,
  makeSingleTrackerPlanSelector,
  makeSingleTrackerTimelineViewSelector
} from '../../selectors'
import SidebarComponent from '../../components/sidebar/SidebarComponent'
import TrackerComponent from '../../components/tracker/TrackerComponent'
import Profile from '../../classes/profile'
import { LS_HOMEPAGE_KEY } from '../../constants/local_storage'
import GoogleAnalytics from '../../classes/GoogleAnalytics'
import { TRACKER_ENTITY_TYPE_PRIMARY, TRACKER_MODULE, TRACKER_TIMELINE_VIEW } from '../../constants/commons'

import TrackerMetrics from '../../testsupport/apiresults/TrackerMetrics1.json'
import TrackerMetricsTimeline from '../../testsupport/apiresults/TrackerMetricsTimeline.json'
import WordCloud from '../../testsupport/apiresults/WordCloud.json'
import TrackerAllTeasersTrailers from '../../testsupport/apiresults/TrackerAllTeasersTrailers.json'
class TrackerContainer extends React.Component {
  static propTypes = {
    isAdmin: PropTypes.bool.isRequired,
    profile: Profile.PropTypes,
    topic: PropTypes.object,
    logout: PropTypes.func.isRequired,
    history: PropTypes.object,
    location: PropTypes.object.isRequired,
    shortcut: PropTypes.shape({
      id: PropTypes.string.isRequired,
      expires_at: PropTypes.string.isRequired,
      target: PropTypes.string.isRequired,
      target_id: PropTypes.string.isRequired
    }),
    tracker: PropTypes.object,
    trackerId: PropTypes.string,
    selectedTrackerEntityType: PropTypes.string,
    trackerPlan: PropTypes.object,
    trackerTimelineMetrics: PropTypes.object,
    primaryEntityDetails: PropTypes.object,
    teasersAndTrailers: PropTypes.object,
    wordCloud: PropTypes.object,
    dailyEngagementTeasersTrailers: PropTypes.object,
    fetchTracker: PropTypes.func.isRequired,
    fetchTrackerTimelineView: PropTypes.func.isRequired,
    fetchGroupTracker: PropTypes.func.isRequired,
    fetchTrackerPrimaryEntityDetails: PropTypes.func.isRequired,
    fetchTrackerTeasersAndTrailers: PropTypes.func.isRequired,
    fetchWhatsNew: PropTypes.func.isRequired,
    fetchWordCloud: PropTypes.func.isRequired,
    setTrackerSelectedEntity: PropTypes.func.isRequired,
    setSingleTrackerSelectedEntity: PropTypes.func.isRequired,
    selectedNav: PropTypes.string,
    isContentIntelligence: PropTypes.bool,
    isCatalogAnalysis: PropTypes.bool,
    isPerformanceAnalysis: PropTypes.bool,
    isAIInsights: PropTypes.bool,
    selectedSidebarNav: PropTypes.func,
    trackerAverageBenchMarkPlan: PropTypes.object,
    trackerAverageBenchMarkTimelineMetrics: PropTypes.object,
    fetchAverageBenchMarkTracker: PropTypes.func.isRequired,
    fetchAverageBenchMarkTrackerTimelineView: PropTypes.func.isRequired,
    fetchSingleTrackerEntity: PropTypes.func,
    fetchSingleTrackerEntityTimelineView: PropTypes.func,
    trackerSinglePlan: PropTypes.object,
    trackerSingleTimelineMetrics: PropTypes.object
  }

  constructor (props) {
    super(props)

    this.state = {
      trackerMetrics: {
        details: TrackerMetrics,
        isFetching: false,
        error: false
      },
      trackerTimelineMetrics: {
        details: TrackerMetricsTimeline,
        isFetching: false,
        error: false
      },
      wordCloud: {
        details: WordCloud,
        isFetching: false,
        error: false
      },
      dailyEngagementTeasersTrailers: TrackerAllTeasersTrailers
    }
  }

  componentDidMount () {
    GoogleAnalytics.trackGA(TRACKER_MODULE, this.props.location, this.props.profile)
    this.fetchData ()
  }

  componentDidUpdate (prevProps) {
    if (prevProps.trackerId !== this.props.trackerId) {
      this.fetchData ()
    }
    if (prevProps.trackerPlan != this.props.trackerPlan && this.props.trackerPlan.details) {
      const trackerId = this.props.trackerId
      const topicId = this.props.trackerPlan.details.primary_tracker && this.props.trackerPlan.details.primary_tracker.primary_entity_id
      const trackerEntityId = this.props.trackerPlan.details.primary_tracker && this.props.trackerPlan.details.primary_tracker.tracker_entity_id
      let trackerEntityIds = this.props.trackerPlan.details.benchmarks && this.props.trackerPlan.details.benchmarks.map(b => b.tracker_entity_id)
      if (topicId) {
        this.props.fetchTrackerPrimaryEntityDetails(trackerId, topicId)
      }
      if (trackerEntityId) {
        this.props.setTrackerSelectedEntity(trackerId, trackerEntityId, TRACKER_ENTITY_TYPE_PRIMARY)
        this.props.fetchTrackerTeasersAndTrailers(trackerId, trackerEntityId)
      }
      if (trackerEntityIds && trackerEntityIds.length > 0){
        trackerEntityIds.map(id => this.props.fetchTrackerTeasersAndTrailers(trackerId, id))
      }
      if (this.props.trackerPlan.details.tracker_topic.default_view === TRACKER_TIMELINE_VIEW || (this.props.trackerPlan.details.tracker_topic.timeline_view_start_date || this.props.trackerPlan.details.tracker_topic.timeline_view_end_date)) {
        this.props.fetchTrackerTimelineView(trackerId)
      }
      if (this.props.trackerPlan.details.tracker_topic.is_average_benchmark_displayed) {
        this.props.fetchAverageBenchMarkTracker(trackerId)
        this.props.fetchAverageBenchMarkTrackerTimelineView(trackerId)
      }
    }
  }

  fetchData = () => {
    const homepage = JSON.parse(localStorage.getItem(LS_HOMEPAGE_KEY))
    if (!homepage) {
      if (this.props.profile && this.props.profile.groups.length > 0) {
        const groups = this.props.profile.groups
        const groupName = groups.filter(group => group !== 'Admin')[0]
        this.props.fetchGroupTracker(groupName)
      }
    }
    const trackerId = this.props.trackerId
    this.props.fetchTracker(trackerId)
    this.props.fetchTrackerTimelineView(trackerId)
  }

  render () {
    const {profile, topic, location, history, tracker, trackerPlan, trackerTimelineMetrics, primaryEntityDetails, teasersAndTrailers, wordCloud, dailyEngagementTeasersTrailers, selectedNav, isContentIntelligence, isCatalogAnalysis, isPerformanceAnalysis, isAIInsights, trackerAverageBenchMarkPlan, trackerAverageBenchMarkTimelineMetrics, trackerSinglePlan, trackerSingleTimelineMetrics} = this.props
    const homepage = JSON.parse(localStorage.getItem(LS_HOMEPAGE_KEY))
    const myLogout = () => this.props.logout()
    const fetchSingleTrackerPlanData = (trackerId, trackerEntityId) => this.props.fetchSingleTrackerEntity(trackerId, trackerEntityId)
    const fetchSingleTrackerTimeLineViewData = (trackerId, trackerEntityId) => this.props.fetchSingleTrackerEntityTimelineView(trackerId, trackerEntityId)
    return (
      <>
        <SidebarComponent
          isAdmin={this.props.isAdmin}
          profile={profile}
          topic={topic}
          logout={myLogout}
          location={location}
          shortcut={this.props.shortcut}
          homepage={tracker.details ? tracker : homepage}
          selectedSidebarNav={this.props.selectedSidebarNav}
          selectedNav={selectedNav}
          isContentIntelligence={isContentIntelligence}
          isCatalogAnalysis={isCatalogAnalysis}
          isPerformanceAnalysis={isPerformanceAnalysis}
          isAIInsights={isAIInsights}
        />
        <TrackerComponent
          isAdmin={this.props.isAdmin}
          history={history}
          tracker={tracker.details ? tracker : homepage}
          trackerId={this.props.trackerId}
          trackerPlan={trackerPlan}
          //trackerPlan={this.state.trackerMetrics ? this.state.trackerMetrics : trackerPlan}
          trackerTimelineMetrics={trackerTimelineMetrics}
          trackerAverageBenchMarkPlan={trackerAverageBenchMarkPlan}
          trackerAverageBenchMarkTimelineMetrics={trackerAverageBenchMarkTimelineMetrics}
          //trackerTimelineMetrics={this.state.trackerTimelineMetrics ? this.state.trackerTimelineMetrics : trackerTimelineMetrics}
          primaryEntityDetails={primaryEntityDetails}
          teasersAndTrailers={teasersAndTrailers}
          wordCloud={wordCloud}
          //wordCloud={this.state.wordCloud}
          shortcut={this.props.shortcut}
          setTrackerSelectedEntity={this.props.setTrackerSelectedEntity}
          setSingleTrackerSelectedEntity={this.props.setSingleTrackerSelectedEntity}
          selectedTrackerEntityType={this.props.selectedTrackerEntityType}
          fetchTrackerTeasersAndTrailers={this.props.fetchTrackerTeasersAndTrailers}
          fetchWhatsNew={this.props.fetchWhatsNew}
          fetchWordCloud={this.props.fetchWordCloud}
          dailyEngagementTeasersTrailers={dailyEngagementTeasersTrailers}
          fetchSingleTrackerPlanData={fetchSingleTrackerPlanData}
          fetchSingleTrackerTimeLineViewData={fetchSingleTrackerTimeLineViewData}
          //dailyEngagementTeasersTrailers={this.state.dailyEngagementTeasersTrailers}
          trackerSinglePlan={trackerSinglePlan}
          trackerSingleTimelineMetrics={trackerSingleTimelineMetrics}
        />
      </>
    )
  }
}

const mapStateToProps = () => {
  const trackerIdSelector = makeTrackerIdSelector()
  const trackerPlanSelector = makeTrackerPlanSelector()
  const trackerTimelineViewSelector = makeTrackerTimelineViewSelector()
  const trackerAverageBenchMarkPlanSelector = makeAverageBenchMarkTrackerPlanSelector()
  const trackerAverageBenchMarkTimelineViewSelector = makeAverageBenchMarkTrackerTimelineViewSelector()
  const trackerSinglePlanSelector = makeSingleTrackerPlanSelector()
  const trackerSingleTimelineViewSelector = makeSingleTrackerTimelineViewSelector()
  const primaryEntityDetailsSelector = makeTrackerPrimaryEntitySelector()
  const teasersAndTrailersSelector = makeTrackerTeasersAndTrailersSelector()
  const trackerTeasersAndTrailersSelector = makeTeaserAndTrailerState()
  return (state, ownProps ) => {
    const isAdmin = state.user.isAdmin
    const profile = state.user.profile && new Profile(state.user.profile)
    const trackerId = trackerIdSelector(state, ownProps)
    const tracker = state.tracker.list
    const selectedTrackerEntityType = state.tracker.trackerEntityType
    const trackerPlan = trackerPlanSelector(state, ownProps)
    const trackerTimelineMetrics = trackerTimelineViewSelector(state, ownProps)
    const trackerAverageBenchMarkPlan = trackerAverageBenchMarkPlanSelector(state, ownProps)
    const trackerAverageBenchMarkTimelineMetrics = trackerAverageBenchMarkTimelineViewSelector(state, ownProps)
    const trackerSinglePlan = trackerSinglePlanSelector(state, ownProps)
    const trackerSingleTimelineMetrics = trackerSingleTimelineViewSelector(state, ownProps)
    const primaryEntityDetails = primaryEntityDetailsSelector(state, ownProps)
    const teasersAndTrailers = teasersAndTrailersSelector(state, ownProps)
    const wordCloud = {}
    const shortcut = ownProps.shortcut
    const dailyEngagementTeasersTrailers = trackerTeasersAndTrailersSelector(state, ownProps)
    const selectedNav = state.sidebar.selectedNav
    const isContentIntelligence = state.sidebar.isContentIntelligence
    const isCatalogAnalysis = state.sidebar.isCatalogAnalysis
    const isPerformanceAnalysis = state.sidebar.isPerformanceAnalysis
    const isAIInsights = state.sidebar.isAIInsights

    return {
      isAdmin,
      profile,
      trackerId,
      tracker,
      trackerPlan,
      trackerTimelineMetrics,
      selectedTrackerEntityType,
      primaryEntityDetails,
      teasersAndTrailers,
      wordCloud,
      shortcut,
      dailyEngagementTeasersTrailers,
      selectedNav,
      isContentIntelligence,
      isCatalogAnalysis,
      isPerformanceAnalysis,
      trackerAverageBenchMarkPlan,
      trackerAverageBenchMarkTimelineMetrics,
      trackerSinglePlan,
      trackerSingleTimelineMetrics,
      isAIInsights
    }
  }
}

function mapDispatchToProps () {
  return (dispatch) => {
    return {
      fetchGroupTracker: (groupName) => dispatch(fetchGroupTrackerIfNeeded(groupName)),
      fetchTracker: (trackerId) => dispatch(fetchTrackerPlanIfNeeded(trackerId)),
      fetchTrackerTimelineView: (trackerId) => dispatch(fetchTrackerTimelineViewIfNeeded(trackerId)),
      fetchAverageBenchMarkTracker: (trackerId) => dispatch(fetchAverageBenchMarkTrackerPlanIfNeeded(trackerId)),
      fetchAverageBenchMarkTrackerTimelineView: (trackerId) => dispatch(fetchAverageBenchMarkTrackerTimelineViewIfNeeded(trackerId)),
      fetchTrackerPrimaryEntityDetails: (trackerId, topicId) => dispatch(fetchTrackerPrimaryEntityDetailsIfNeeded(trackerId, topicId)),
      fetchTrackerTeasersAndTrailers: (trackerId, trackerEntityId) => dispatch(fetchTrackerTeasersAndTrailersIfNeeded(trackerId, trackerEntityId)),
      fetchSingleTrackerEntity: (trackerId, trackerEntityId) => dispatch(fetchSingleTrackerEntityPlanIfNeeded(trackerId, trackerEntityId)),
      fetchSingleTrackerEntityTimelineView: (trackerId, trackerEntityId) => dispatch(fetchSingleTrackerEntityTimelineViewIfNeeded(trackerId, trackerEntityId)),
      fetchWhatsNew: (trackerId, trackerEntityId, launchDate) => dispatch(fetchTrackerpageWhatsNewIfNeeded(trackerId, trackerEntityId, launchDate)),
      fetchWordCloud: (trackerId, entityId) => dispatch(fetchTrackerpageWordCloudIfNeeded(trackerId, entityId)),
      setTrackerSelectedEntity: (trackerId, trackerEntityId, trackerEntityType) => dispatch(setTrackerSelectedEntity(trackerId, trackerEntityId, trackerEntityType)),
      setSingleTrackerSelectedEntity: (trackerId, trackerEntityId, trackerEntityType) => dispatch(setSingleTrackerSelectedEntity(trackerId, trackerEntityId, trackerEntityType)),
      selectedSidebarNav: (nav) => dispatch(setSelectedSidebarNav(nav)),
      logout: () => dispatch(logout())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TrackerContainer)
